{{#if ready}}
   {{#each heroCarouselContent}}
        <div class="heroCarouselImageCache"><img src="{{ background }}" alt="{{ heading }}"/></div>
    {{/each}}
    <div class="heroCarsouel-heroProductImg" style="background-image: url('{{ background }}')">
        <div class="heroCarsouel-heroProductImg-bannerSubmediumViewport">Create Brilliant Print.</div>
    </div>
    <div class="heroCarousel-innerContent">
        <h2 class="heroCarousel-innerContent-hdg">{{ heading }}</h2>
        <p class="heroCarousel-innerContent-bdcpy">{{{ bodyCopy }}}</p>
        <a class="heroCarousel-innerContent-cta" href="{{ href }}">{{ cta }}</a>
    </div>
    <div class="dsPagination heroCarouselPagination">
            <div class="dsPagination-indicator">
                {{#each heroCarouselContent}}
                    <div class="dsPagination-indicator-page{{#if isCurrent }} isCurrent{{/if}}"></div>
                {{/each}}
            </div>
            <div class="dsPagination-controls">
                <div class="dsPagination-controls-prev js--action--heroCarouselPrev"></div>
                <div class="dsPagination-controls-page">{{ currentCarouselPage }}/{{ totalCarouselPages }}</div>
                <div class="dsPagination-controls-next js--action--heroCarouselNext"></div>
            </div>
        </div>
    <div class="heroCarousel-bannerPreSubmediumViewport">Create Brilliant Print.</div>
{{/if}}
